import { createSelector } from 'reselect';
import { getInsurances } from './getInsurances';
import { getUsers } from '~shared/features/users/selectors/getUsers';
import { type UserIDParam } from '~shared/selectors/selectorParamTypes';
import { type Insurance, type ReduxStateShared } from '~shared/types';

export const getUserInsurances = createSelector([getUsers, getInsurances], (users, insurances) => {
  const insurancesByUser: Record<number, Insurance[]> = {};

  users.forEach(({ id }) => {
    insurancesByUser[id] = insurances.filter(({ user_id }) => user_id === id);
  });

  return insurancesByUser;
});

const getUserID = (_: ReduxStateShared, props: UserIDParam) => props.userID;

export const getInsurancesForUser = createSelector([getUserID, getUserInsurances], (userID, insurancesByUser) => {
  if (!userID) {
    return [];
  }

  return insurancesByUser[userID] || [];
});
